import axiosInstance from '../../utils/setupAxios';

// Action Types
export const MERGE_FROM_DEVICE_REQUEST = 'MERGE_FROM_DEVICE_REQUEST';
export const MERGE_FROM_DEVICE_SUCCESS = 'MERGE_FROM_DEVICE_SUCCESS';
export const MERGE_FROM_DEVICE_FAILURE = 'MERGE_FROM_DEVICE_FAILURE';

export const DELETE_ALL_SYNC_SONGS_REQUEST = 'DELETE_ALL_SYNC_SONGS_REQUEST';
export const DELETE_ALL_SYNC_SONGS_SUCCESS = 'DELETE_ALL_SYNC_SONGS_SUCCESS';
export const DELETE_ALL_SYNC_SONGS_FAILURE = 'DELETE_ALL_SYNC_SONGS_FAILURE';

// Merge from Device Actions
export const mergeFromDeviceRequest = () => ({
  type: MERGE_FROM_DEVICE_REQUEST
});

export const mergeFromDeviceSuccess = (data) => ({
  type: MERGE_FROM_DEVICE_SUCCESS,
  payload: data
});

export const mergeFromDeviceFailure = (error) => ({
  type: MERGE_FROM_DEVICE_FAILURE,
  payload: error
});

export const mergeFromDevice = (deviceId, userId, dryRun = false, page = 1, itemsPerPage = 1000, taskIds = null) => {
  return async (dispatch) => {
    dispatch(mergeFromDeviceRequest());
    try {
      const payload = {
        device_id: deviceId,
        user_id: userId,
        dry_run: dryRun ? 1 : 0,
        page: dryRun ? page : undefined,
        items_per_page: dryRun ? itemsPerPage : undefined
      };
      if (!dryRun && taskIds && taskIds.length > 0) {
        payload.task_ids = taskIds;
      }
      const response = await axiosInstance.post('/songs/merge-from-device', payload);
      
      if (response.data.success) {
        dispatch(mergeFromDeviceSuccess(response.data.data));
        return response.data;
      } else {
        dispatch(mergeFromDeviceFailure(response.data.message || 'Failed to merge songs'));
        throw new Error(response.data.message || 'Failed to merge songs');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to merge songs';
      dispatch(mergeFromDeviceFailure(errorMessage));
      throw error;
    }
  };
};

// Delete All Sync Songs Actions
export const deleteAllSyncSongsRequest = () => ({
  type: DELETE_ALL_SYNC_SONGS_REQUEST
});

export const deleteAllSyncSongsSuccess = (data) => ({
  type: DELETE_ALL_SYNC_SONGS_SUCCESS,
  payload: data
});

export const deleteAllSyncSongsFailure = (error) => ({
  type: DELETE_ALL_SYNC_SONGS_FAILURE,
  payload: error
});

export const deleteAllSyncSongs = (userId) => {
  return async (dispatch) => {
    dispatch(deleteAllSyncSongsRequest());
    try {
      const response = await axiosInstance.delete('/songs/delete-all-sync-songs', {
        data: { user_id: userId }
      });
      
      if (response.data.success) {
        dispatch(deleteAllSyncSongsSuccess(response.data.data));
        return response.data;
      } else {
        dispatch(deleteAllSyncSongsFailure(response.data.message || 'Failed to delete songs'));
        throw new Error(response.data.message || 'Failed to delete songs');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete songs';
      dispatch(deleteAllSyncSongsFailure(errorMessage));
      throw error;
    }
  };
};
